export default "__VITE_ASSET__bLDOCXTg__"